import { useState } from 'react';

// Placeholder data
const mockUsers = [
  { id: '1', telegram_id: 123456789, full_name: 'Juan Pérez', role: 'client', wallet_balance: 150.00, created_at: '2024-01-15' },
  { id: '2', telegram_id: 234567890, full_name: 'María García', role: 'client', wallet_balance: 75.50, created_at: '2024-02-20' },
  { id: '3', telegram_id: 345678901, full_name: 'Carlos Admin', role: 'admin_compras', wallet_balance: 0, created_at: '2024-01-01' },
  { id: '4', telegram_id: 456789012, full_name: 'Ana Master', role: 'master', wallet_balance: 0, created_at: '2023-12-01' },
];

const roles = ['client', 'admin_finanzas', 'admin_compras', 'admin_logistica', 'master'];

const roleLabels: Record<string, string> = {
  client: 'Cliente',
  admin_finanzas: 'Admin Finanzas',
  admin_compras: 'Admin Compras',
  admin_logistica: 'Admin Logística',
  master: 'Master Admin',
};

export default function Users() {
  const [users, setUsers] = useState(mockUsers);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredUsers = users.filter((user) =>
    user.full_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleRoleChange = (userId: string, newRole: string) => {
    setUsers(users.map((u) => (u.id === userId ? { ...u, role: newRole } : u)));
    // TODO: Call API to update role
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">Usuarios</h1>
        <input
          type="text"
          placeholder="Buscar usuario..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Nombre</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Telegram ID</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Rol</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-500">Saldo</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Registro</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {filteredUsers.map((user) => (
                <tr key={user.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm font-medium">{user.full_name}</td>
                  <td className="px-4 py-3 text-sm text-gray-500">{user.telegram_id}</td>
                  <td className="px-4 py-3">
                    <select
                      value={user.role}
                      onChange={(e) => handleRoleChange(user.id, e.target.value)}
                      className="px-2 py-1 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      {roles.map((role) => (
                        <option key={role} value={role}>
                          {roleLabels[role]}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="px-4 py-3 text-sm text-right">
                    ${user.wallet_balance.toFixed(2)}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500">
                    {new Date(user.created_at).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}